import { render, staticRenderFns } from "./AppointmentSubtitle.vue?vue&type=template&id=fa08642c&scoped=true&"
import script from "./AppointmentSubtitle.vue?vue&type=script&lang=js&"
export * from "./AppointmentSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08642c",
  null
  
)

export default component.exports